<template>
  <CustomTable title="Наборы материалов" :rowsData="this.rowsData" :columns="packageTableColumns" :stickyHeader="true"
    :loading="isFetching" :custom-body="true" :small="true" :height="200">
    <template #top-right>
      <slot name="top-right">
        <q-btn :loading="isFetching" @click="refetch" color="primary" size="sm">
          <q-icon name="replay" />
        </q-btn>
      </slot>
    </template>

    <template #customBody="props" v-if="!isFetching">
      <q-tr>
        <custom-table-cell align="center" vertical-align="center" style="width: 50px;">
          {{ props.row.material_set_id }}
        </custom-table-cell>

        <custom-table-cell align="left" vertical-align="center" style="width: 100px;">
          <span>{{ props.row.set_name }}</span>
        </custom-table-cell>

        <custom-table-cell align="left" vertical-align="top" class="materials-cell">
          <div class="materials-list">
            <div v-for="material in props.row.materials" :key="material.material_id" class="material-item"
              :class="{ 'material-item--main': material.is_main }">
              <div style="width: 50%;">
                <span class="material-name">
                  {{ material.material_id }} - {{ material.material_name }}
                  <span v-if="material.is_main" class="main-badge">(основной)</span>
                </span>
              </div>
              <div class="material-details" style="width: 38%;">
                <strong>{{ material.formula }}</strong>
              </div>
              <div class="material-details" style="width: 9%;">
                Расход: <strong>{{ material.consumption }}</strong>
              </div>
            </div>
          </div>
        </custom-table-cell>

        <custom-table-cell align="center" vertical-align="center" style="width: 50px;">
          <CustomIcon icon="edit" title="Редактировать" @click="handleEditClick(props.row)" />
        </custom-table-cell>
      </q-tr>
    </template>
  </CustomTable>
</template>

<script>
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import { getMaterialSets, packageTableColumns, updMaterialSets } from "@/views/PackageList/services";
import { useAppStore } from "@/services/store/app"
import CustomIcon from "@/components/common/CustomIcon";
import { MODAL_NAMES } from "@/constants";

export default {
  name: "packageList",
  components: { CustomTableCell, CustomTable, CustomIcon },
  data() {
    return {
      packageTableColumns,
      rowsData: [],
      isFetching: false,
      filters: {
        material_set_id: "",
        material_id: "",
      }
    }
  },
  methods: {
    handleEditClick(row) {
      const appStore = useAppStore()
      appStore.showModal(MODAL_NAMES.UpdSet, {
        onSubmit: (body) => this.onUpdateSubmit(body),
        onUpdateTable: (newData) => this.rowsData = newData,
        title: "Редактировать набор",
        body: row,
      })
    },
    async onUpdateSubmit(body) {
      const appStore = useAppStore()

      const res = await updMaterialSets(body);
      if (!res) return;
      this.rowsData = res || []
      this.showSucceedSnackbar();
      appStore.closeModal();
    },
    async getData() {
      this.isFetching = true
      const res = await getMaterialSets()
      if (!res) return;
      this.isFetching = false
      this.rowsData = res || []
    },
  },
  mounted() {
    this.getData()
  },
  setup() {
    const { showSucceedSnackbar } = useCustomSnackbar()
    return { showSucceedSnackbar }
  },
}
</script>

<style scoped lang="scss">
.materials-cell {
  max-width: 400px;
  min-width: 300px;
}

.materials-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 300px;
  overflow-y: auto;
}

.material-item {
  display: flex;
  align-items: center;
  gap: 1%;
  padding: 8px 0;
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
  }

  &--main {
    .material-name {
      color: #2196f3;
      font-weight: 600;
    }

    .main-badge {
      color: #2196f3;
    }
  }
}

.material-name {
  font-size: 13px;
  line-height: 1.4;
  margin-bottom: 4px;
  word-break: break-word;
}

.main-badge {
  font-size: 11px;
  color: #666;
  font-style: italic;
}

.material-details {
  font-size: 12px;
  color: #666;
  line-height: 1.3;
}

.materials-list::-webkit-scrollbar {
  width: 6px;
}

.materials-list::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.materials-list::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 3px;

  &:hover {
    background: #999;
  }
}
</style>